"use client";

import { ArrowTopRightOnSquare } from "@/components/atom/mark/arrowTopRightOnSquare";
import { TimeSchedule } from "@/components/moleculer/events/2024techfes/timeSchedule";
import Link from "next/link";
import type { ReactNode } from "react";

const Card = (props: { title: string; children: ReactNode }) => {
	return (
		<div className={"flex flex-col justify-start px-4 md:px-16 py-4 gap-4"}>
			<p className={"text-2xl md:text-4xl font-bold "}>{props.title}</p>
			<div className={"text-lg md:text-2xl"}>{props.children}</div>
		</div>
	);
};
const CompanyCard = (props: {
	name: string;
	imgPath: string;
	alt: string;
	hasPadding?: boolean;
	url: string;
}) => {
	return (
		<div className={"flex-col flex gap-4"}>
			<img
				src={props.imgPath}
				className={`w-80 h-auto bg-white ${props.hasPadding && "p-8"}`}
				alt={props.alt}
			/>
			<button
				type="button"
				className={"flex hover:cursor-pointer hover:underline"}
				onClick={(): void => {
					window.open(props.url);
				}}
			>
				<p>{props.name}</p>
				<ArrowTopRightOnSquare />
			</button>
		</div>
	);
};
const ApplyButton = () => (
	<button
		type="button"
		className={"bg-black text-white px-20 py-4 w-fit mx-auto text-2xl rounded"}
		onClick={(): void => {
			window.open(
				"https://docs.google.com/forms/d/e/1FAIpQLSe3J78vwHFATry8Fq7U5TqhUOf0_Vt25kujrXCqibhgJOTwSQ/viewform",
			);
		}}
	>
		応募する
	</button>
);

export const AboutLecture = () => {
	const schedules = [
		{
			title: "本イベントについて",
			dateFrom: "19:00",
			dateTo: "19:05",
			height: "h-20",
		},
		{
			title: "ハンズオン説明",
			dateFrom: "19:05",
			dateTo: "19:20",
			height: "h-20",
		},
		{
			title: "NFTについて",
			dateFrom: "19:20",
			dateTo: "19:40",
			height: "h-32",
		},
		{
			title: "Google Cloud について",
			dateFrom: "19:40",
			dateTo: "20:00",
			height: "h-32",
		},
		{
			title: "ハンズオン〜NFT実践〜",
			dateFrom: "20:00",
			dateTo: "21:50",
			height: "h-40",
		},
		{
			title: "ハッカソンの説明",
			dateFrom: "21:50",
			dateTo: "21:55",
			height: "h-20",
		},
		{ title: "写真撮影", dateFrom: "21:55", dateTo: "22:00", height: "h-20" },
	];
	return (
		<div className={"flex flex-col"}>
			<div
				className={
					'bg-[url("/events/2024techfes/cover.png")] text-black py-16 flex flex-col gap-4 '
				}
			>
				<div
					className={
						"bg-white w-full mx-auto p-4 md:p-12 text-lg text-center gap-4 flex flex-col"
					}
				>
					<h2 className={"text-xl md:text-5xl font-bold text-center"}>
						Web3 & クラウドハンズオン
					</h2>
					<p className={"text-xs md:text-lg"}>
						最先端のWeb3技術とクラウドの知識を学べる特別セミナーを開催します！
						<br />
						未来のエンジニアに必要なスキルを身につけ、次世代のITを一緒に探求しませんか？
					</p>
				</div>
				<ApplyButton />
				<div
					className={
						'flex flex-col gap-4 mb-12 w-11/12 md:w-10/12 mx-auto md:py-16 rounded bg-[url("/events/2024techfes/cover_white.svg")]'
					}
				>
					<Card title={"日程"}>
						<p>2024年12月24日（火） 19:00〜</p>
					</Card>
					<Card title={"申込締切"}>
						<p>2024年12月23日（月） 21:00</p>
					</Card>
					<Card title={"会場"}>
						<p>オンライン（特設メタバース内）</p>
					</Card>
					<Card title={"応募条件"}>
						<ul className="list-disc ml-6">
							<li>高専人であること</li>
							<li>自前でパソコンを有していること（Mac、Windowsは問わない）</li>
							<li>全ての時間帯で参加可能であること</li>
						</ul>
					</Card>
					<Card title={"応募フォーム"}>
						<Link
							href={
								"https://docs.google.com/forms/d/e/1FAIpQLSe3J78vwHFATry8Fq7U5TqhUOf0_Vt25kujrXCqibhgJOTwSQ/viewform"
							}
							className={"underline text-sky-600"}
						>
							応募はこちら
						</Link>
					</Card>
					<Card title={"タイムスケジュール"}>
						<TimeSchedule schedules={schedules} date={"2024年12月24日（火）"} />
					</Card>
					<Card title={"主催"}>
						<CompanyCard
							name={"株式会社プロッセル"}
							imgPath={"/events/2024techfes/prossell.png"}
							alt={"プロッセルロゴ"}
							url={"https://prossell.jp/"}
							hasPadding
						/>
					</Card>
					<Card title={"協力"}>
						<CompanyCard
							name={"国立大学法人 長岡技術科学大学"}
							imgPath={"/events/2024techfes/nut.svg"}
							alt={"長岡技科大ロゴ"}
							url={"https://www.nagaokaut.ac.jp/"}
							hasPadding
						/>
					</Card>
				</div>
				<ApplyButton />
			</div>
		</div>
	);
};
